import React, { useEffect, useState, useRef } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'

import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import DataTable from 'Shared/Components/DataTable'

const SystemAdmins = () => {
  const { setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { send } = useFetchData()

  const [users, setUsers] = useState([])
  const tableRef = useRef()

  const filterRef = useRef({
    "search": ""
  })

  const loadData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/user/admins`,
      params: {
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"],
        "search": filterRef.current.search,
      },
      returnType: "json"
    })

    body && setUsers({
      "data": body["data"].map((i) => ({
        "user_id": i["user_id"],
        "username": i["username"],
        "email": i["email"]
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await loadData()

      setPageLoading(false)
    }

    init()
  }, [])

  const onSearch = async (value, _e, info) => {    
    filterRef.current.search = value

    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  const reload = async () => {
    tableRef.current.setTableLoading(true)

    await loadData()

    tableRef.current.setTableLoading(false)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={users["data"]} count={users["count"]} ref={tableRef} onSearch={onSearch} loadData={reload}
              columns={{
                "username": { "label": t("users_username"), "sorting": false, "nowrap": true },
                "email": { "label": t("users_email"), "sorting": false, "nowrap": true },
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container>
  </>)
}

export default SystemAdmins
